// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import { debugConfigSelector } from '../../../selectors/configSelectors';
import { tisConfigSelector } from '../../../selectors/appSelectors';
import { vehicleListSelector } from '../../../selectors/vehicleSelectors';
import { carEntitiesSelector } from '../../../selectors/carSelectors';
import { planeEntitiesSelector } from '../../../selectors/planeSelectors';
import appActions from '../../../actions/appActions';
import carActions from '../../../actions/carActions';
import planeActions from '../../../actions/planeActions';
import SyncTargets from '../SyncTargets';
import type { Props } from '../SyncTargets';

const mapStateToProps = (state: State) => {
    return {
        vehicles: vehicleListSelector(state),
        carEntities: carEntitiesSelector(state),
        planeEntities: planeEntitiesSelector(state),
        debugConfig: debugConfigSelector(state),
        tisConfig: tisConfigSelector(state)
    };
};

const mapDispatchToProps = {
    setTisEnabled: appActions.setTisEnabled,
    setCar: carActions.setCar,
    setCars: carActions.setCars,
    setPlane: planeActions.setPlane,
    setPlanes: planeActions.setPlanes
};

export default connect<Props, _, _, _, _, _>(mapStateToProps, mapDispatchToProps)(SyncTargets);